import PublicChannel from "./public-channel";

export default class PrivateChannel extends PublicChannel {
  //
}
